import {faDatabase} from "@fortawesome/free-solid-svg-icons";

export default faDatabase;
